/**
 * API Configuration
 * 
 * This file contains configuration for the API endpoints and base URLs.
 * Easily switch between different environments by changing the values here.
 */

// Environment Configuration
export const API_CONFIG = {
  // Base URLs for different environments
  DEVELOPMENT: 'https://1130lab:5001/api/v1',
  STAGING: 'https://staging-api.doyentrading.com',
  PRODUCTION: 'https://api.doyentrading.com',
  
  // Current environment - change this to switch environments quickly
  CURRENT_ENV: 'DEVELOPMENT' as 'DEVELOPMENT' | 'STAGING' | 'PRODUCTION',
  
  // Get the current base URL
  get BASE_URL() {
    // First check for environment variable (for production builds)
    if (import.meta.env.VITE_API_BASE_URL) {
      return import.meta.env.VITE_API_BASE_URL;
    }
    
    // Fall back to config setting
    return this[this.CURRENT_ENV];
  },
  
  // Request timeout in milliseconds
  TIMEOUT: 60000000,
  
  // Enable API request/response logging
  DEBUG: import.meta.env.DEV || false,
};

// Quick environment switchers (for development)
export const switchToEnvironment = (env: 'DEVELOPMENT' | 'STAGING' | 'PRODUCTION') => {
  API_CONFIG.CURRENT_ENV = env;
  console.log(`API environment switched to: ${env} (${API_CONFIG.BASE_URL})`);
};

// Utility functions for testing
export const getApiUrl = (endpoint: string) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const logApiConfig = () => {
  console.log('API Configuration:', {
    currentEnv: API_CONFIG.CURRENT_ENV,
    baseUrl: API_CONFIG.BASE_URL,
    timeout: API_CONFIG.TIMEOUT,
    debug: API_CONFIG.DEBUG,
  });
};

// Export for use in other files
export default API_CONFIG;
